module.exports = __webpack_public_path__ + "img/vote.8c7ab84b.svg";